import React, { useState, useRef, useEffect } from "react";
import './VideoPlayer.css';

export const VideoPlayer = () => {
  const videoRef = useRef();
  const [isPlaying, setIsPlaying] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return undefined;
    // Below-the-fold: don't download/play until it scrolls near view (paired with
    // preload="none"), so it doesn't compete with the above-the-fold load.
    const io = new IntersectionObserver((entries) => {
      if (entries[0] && entries[0].isIntersecting) {
        video.play().then(() => setIsPlaying(true)).catch(() => setIsPlaying(false));
        io.disconnect();
      }
    }, { rootMargin: "200px" });
    io.observe(video);
    return () => io.disconnect();
  }, []);

  const handleVideoClick = () => {
    setButtonClicked(true);
    setTimeout(() => setButtonClicked(false), 200); // Reset after animation

    const video = videoRef.current;
    if (video.paused) {
      video.play();
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };

  return (
    <div className="video-container">
      <video
        className="video-player"
        ref={videoRef}
        loop
        muted
        preload="none"
        playsInline
        onClick={handleVideoClick}>
        <source
          src="https://d5l8cb2ud43ux.cloudfront.net/Homepage_Background_Video_enzxjh.webm"
          type="video/webm" />
        <source
          src="https://d5l8cb2ud43ux.cloudfront.net/Homepage_Background_Video_enzxjh.mp4"
          type="video/mp4" />
      </video>
      <div className='video-overlay'>
        <img src="./assets/images/chooseblends.png" alt="Overlay" />
        <button className={`play-button ${buttonClicked ? 'clicked' : ''}`} onClick={handleVideoClick}>
          <img 
            src={isPlaying ? "./assets/images/pause.png" : "./assets/images/play.png"}
            alt={isPlaying ? "Pause" : "Play"} 
          />
        </button>
      </div>
    </div>
  );
};
